import { Controller } from "@hotwired/stimulus"
import { buildCron, parseCron, describeCron, MODE_ADVANCED } from "../src/cron_schedule"

// Przyjazny wybór harmonogramu: user wybiera częstotliwość (co X minut / co godzinę /
// codziennie / co tydzień / co miesiąc) i godzinę, a kontroler składa z tego wyrażenie cron
// do ukrytego pola wysyłanego z formularzem. Tryb "zaawansowany" pozwala wpisać wyrażenie
// wprost - tam też wracają wartości, których prostymi polami nie da się przedstawić
// (zakresy, listy, zapis naturalny typu "every day at 3am"), żeby edycja ich nie gubiła.
export default class extends Controller {
  static targets = ["output", "mode", "field", "interval", "minute", "hour", "weekday",
    "monthday", "raw", "preview", "expression"]

  static values = { labels: Object }

  connect() {
    const state = parseCron(this.outputTarget.value)
    this.modeTarget.value = state.mode
    this.intervalTarget.value = state.interval
    this.minuteTarget.value = state.minute
    this.hourTarget.value = state.hour
    this.weekdayTarget.value = state.weekday
    this.monthdayTarget.value = state.monthday
    this.rawTarget.value = state.raw
    // oryginalne wyrażenie zaawansowane - przywracane przy powrocie do trybu zaawansowanego,
    // dopóki user sam nie edytuje pola raw (zabawa selectami nie może go bezpowrotnie nadpisać)
    this.originalRaw = state.mode === MODE_ADVANCED ? state.raw : null
    this.render()
  }

  // Zmiana dowolnego pola buildera - przelicz wyrażenie i odśwież opis
  update(event) {
    // user sam zmienił wyrażenie - od teraz punktem odniesienia jest jego wpis, nie oryginał
    if (event && event.target === this.rawTarget) this.originalRaw = null
    this.render()
  }

  render() {
    const mode = this.modeTarget.value
    // pola prostego trybu deklarują, w których trybach mają sens (data-schedule-modes)
    this.fieldTargets.forEach((field) => {
      field.hidden = !(field.dataset.scheduleModes || "").split(" ").includes(mode)
    })

    if (mode === MODE_ADVANCED) {
      // powrót do trybu zaawansowanego pokazuje oryginalne wyrażenie, nie złożone z selectów
      if (this.originalRaw != null) this.rawTarget.value = this.originalRaw
      this.outputTarget.value = this.rawTarget.value.trim()
    } else {
      this.outputTarget.value = buildCron(this.state(mode)) || ""
      // bez oryginału przełączenie na tryb zaawansowany startuje od aktualnie złożonego wyrażenia
      if (this.originalRaw == null) this.rawTarget.value = this.outputTarget.value
    }

    this.expressionTarget.textContent = this.outputTarget.value
    this.previewTarget.textContent = mode === MODE_ADVANCED
      ? ""
      : describeCron(this.state(mode), this.labelsValue)
  }

  state(mode) {
    return {
      mode,
      interval: this.intervalTarget.value,
      minute: this.minuteTarget.value,
      hour: this.hourTarget.value,
      weekday: this.weekdayTarget.value,
      monthday: this.monthdayTarget.value,
    }
  }
}
